<template>
  <div>
    <b-modal 
      centered 
      :id="id"
      :title="title" 
      class="modal-primary" 
      size="xl"
      header-bg-variant="primary"
      ok-variant="primary"      
      scrollable 
      @ok="$emit('okClick')"
    >
      <template #modal-ok>Скачать</template>
      <template #modal-cancel>Отмена</template>

      <field-selector :itemsIn="itemsIn" v-model="value"/>
      
    </b-modal>
  </div>
</template>

<script>
import FieldSelector from './FieldSelector.vue';

export default {
  name: 'field-selector-modal',

  components: { FieldSelector },

  props: {
    id: {     
      type: String,
      default: 'field-selector-modal'
    },
    title: {
      type: String,
      default: null
    },
    itemsIn: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {}
    }
  },

  
}

</script>

